import { render, staticRenderFns } from "./AssembleiaList.vue?vue&type=template&id=11f6ce08&scoped=true&"
import script from "./AssembleiaList.vue?vue&type=script&lang=js&"
export * from "./AssembleiaList.vue?vue&type=script&lang=js&"
import style0 from "./AssembleiaList.vue?vue&type=style&index=0&id=11f6ce08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6ce08",
  null
  
)

export default component.exports